class CartService {
    constructor(){
        this.baseUrl = window.Shopify?.routes?.root || '/';
    }

    static instance = null;

    static getInstance() {
        if (!CartService.instance) {
            CartService.instance = new CartService();
        }
        return CartService.instance;
    }

    async getCart(handle) {
        try {
            const response = await fetch(`${this.baseUrl}cart.js`);
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const product = await response.json();
            return product;
        } catch (e) {
            console.error(`Failed to fetch product ${handle}:`, e);
            return null;
        }
    }

    async addToCart(items){
        try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            });
            
            const result = await response.json();
            return result;
          } catch (error) {
            console.error('Erro:', error);
            return null;
          }
    }
    
    async updateCart(items){
        try {
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            });
            
            const result = await response.json();
            return result;
          } catch (error) {
            console.error('Erro:', error);
            return null;
          }
    }
}